import { motion } from "framer-motion";
import { profile, education } from "../data/portfolio";

export default function Hero() {
  return (
    <section className="hero-section">
      <div className="hero-video-wrap">
        <video autoPlay muted loop playsInline className="hero-video">
          <source src="/assets/1.mp4" type="video/mp4" />
        </video>
        <div className="hero-overlay" />
      </div>

      <div className="hero-content">
        <motion.div
          className="hero-inner"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
        >
          <p className="hero-eyebrow">Portfolio</p>
          <h1>{profile.name}</h1>
          <p className="hero-tagline">{profile.tagline}</p>

          <div className="hero-education">
            {education.map((item) => (
              <div key={item.degree} className="edu-entry">
                <strong>{item.degree}</strong>
                <span className="edu-meta">
                  {item.school} · {item.years}
                </span>
              </div>
            ))}
          </div>

          <div className="hero-cta">
            <a href="#projects" className="btn btn-primary">
              View Projects
            </a>
            <a href="#publications" className="btn btn-ghost">
              Publications
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
